<template>
  <div class="batch-search">
    <el-dialog
      top="0"
      title="批量搜索"
      class="dialog-full-small"
      :visible.sync="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :before-close="handleClose"
      @open="handleOpen"
    >
      <div>
        <div class="margin-right-16">
          <div
            v-if="text"
            class="search-text"
          >
            {{text}}：
          </div>
          <div v-else>
            <el-select
              v-model="form.searchType"
              placeholder="请选择"
              :size="formSize"
              @change="handlerValidator('searchType')"
            >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <div
              v-if="rules.searchType.isShow"
              class="item-input__error"
            >
              {{rules.searchType.message}}
            </div>
          </div>
        </div>
        <div class="dialog-textarea">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 10}"
            :placeholder="tips"
            v-model="form.searchKey"
            @input="handlerValidator('searchKey')"
          />
          <div
            v-if="rules.searchKey.isShow"
            class="item-input__error"
          >
            {{rules.searchKey.message}}
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="handleClose()"
          :size="formSize"
          :loading="loading"
        >取消</el-button>
        <el-button
          type="primary"
          :size="formSize"
          :loading="loading"
          v-track="form"
          :trackCode="trackCode"
          @click="handleConfirm()"
        >确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const formDefault = {
  searchKey: '', // 搜索值
  searchType: '',
  list: [],
};
const rulesDefault = {
  searchType: { isShow: false, message: '请选择搜索类型' },
  searchKey: { isShow: false, message: '请输入内容' },
};
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    typeList: {
      type: Array,
      default: () => [],
    },
    searchType: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    tips: {
      type: String,
      default: '多个查询，请使用换行或英文逗号分隔',
    },
    trackCode: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(formDefault)),
      rules: JSON.parse(JSON.stringify(rulesDefault)),
      isOK: 0,
    };
  },
  methods: {
    /**
     * 校验
     * tyep: 1 = 法人身份证; 2 = 法人手机号
     * val: 传入的key
    */
    handlerValidator(val) {
      let num = 0;
      Object.keys(this.form).forEach((key) => {
        // 如果有传参数，则单独校验该参数
        if (val) {
          if (!this.form[val]) {
            this.rules[val].isShow = true;
            num += 1;
          } else {
            this.rules[val].isShow = false;
          }
        } else if (key !== 'list') {
          if (!this.form[key]) {
            // 如果类型为固定的则不校验类型
            if (this.text && key === 'searchType') {
              this.rules[key].isShow = false;
            } else {
              this.rules[key].isShow = true;
              num += 1;
            }
          } else {
            this.rules[key].isShow = false;
          }
        }
      });
      this.isOK = num;
    },
    // 提交
    handleConfirm() {
      this.handlerValidator();
      if (this.isOK > 0) {
        return;
      }
      this.form.list = [];
      let newList = this.form.searchKey.replace(/\s+/g, ',');
      if (newList.length < 2) {
        return;
      }
      if (newList[0] === ',') { // 防止第一位是‘,’
        newList = newList.slice(1);
      }
      const arr = newList.split(',');
      // 过滤空元素
      this.form.list = arr.filter((item) => !!item);
      this.$emit('confirm', this.form);
    },
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.form = JSON.parse(JSON.stringify(formDefault));
        const [current] = this.typeList.filter((item) => item.value === this.searchType);
        this.form.searchType = current ? current.value : this.typeList[0].value;

        this.rules = JSON.parse(JSON.stringify(rulesDefault));
        this.isOK = 0;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.batch-search{
  ::v-deep {
    .el-dialog {
      min-width: 500px;
    }
    .el-button {
      min-width: 64px;
      padding: 8px 16px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
  .item-input__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1.5;
    padding-top: 8px;
    text-align: right;
  }
  .search-text {
    word-break: keep-all;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4D4F51;
  }
  .search-text:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
  .dialog-textarea{
    width: 100%;
    margin-top: 12px;
  }
}
</style>
